<script setup>
const players = [
  'Meiko Lindeberg',
  'Radvilas Kneižys',
  'Justin Lee Wilson',
  'Erik Makke',
  'Otasowie Iyekekpolor',
  'Anton Nufer',
  'Amon Doerries',
  'Martins Piternieks',
  'Marcis Steinbergs',
  'Arturs Strautins',
  'Thijs De Ridder',
  'Matthias Tass',
  'Kaspar Treier',
  'Siim-Sander Vene',
  'Joonas Riismaa'
]
</script>

<template>
  <div class="p-4">
    <div class="bg-white rounded-lg shadow">
      <ul class="divide-y divide-gray-200">
        <li v-for="player in players" :key="player">
          <a href="#" class="flex items-center p-4 hover:bg-gray-50">
            <span>{{ player }}</span>
            <i class="fas fa-chevron-right ml-auto text-gray-400"></i>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template> 